// Full-page redirects and new tabs for Stripe-hosted pages (Checkout,
// Customer Portal). A mutable object rather than bare named exports so
// specs can spy on it — ES module bindings are read-only.
const navigation = {
  // Checkout: same tab, Stripe sends the browser back to /subscription.
  redirectTo: (url) => {
    window.location.assign(url);
  },
  // Portal: a new tab. It must be opened synchronously inside the click
  // handler (before any await) or popup blockers refuse it; the caller
  // points it at the real URL once the server has answered.
  openBlankTab: () => {
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;
    return tab;
  },
  pointTab: (tab, url) => {
    if (tab && !tab.closed) {
      tab.location.href = url;
    } else {
      window.location.assign(url); // blocked popup: fall back to this tab
    }
  },
  closeTab: (tab) => {
    if (tab && !tab.closed) tab.close();
  },
};

export default navigation;
